import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EmptyStateProps {
    title: string
    description?: ReactNode
    action?: ReactNode
    className?: string
}

const EmptyState: FC<EmptyStateProps> = ({ title, description, action, className }): ReactNode => {
    return (
        <div
            role='status'
            className={cn('flex flex-col items-start gap-4 border-y border-dashed border-border-strong py-14', className)}
        >
            <span aria-hidden='true' className='size-2 bg-brand' />

            <p className='font-heading text-heading [font-weight:450]'>
                {title}
            </p>

            {description && (
                <p className='max-w-reading text-body text-muted-foreground'>
                    {description}
                </p>
            )}

            {action}
        </div>
    )
}

export default EmptyState
